import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withKeys as _withKeys, createVNode as _createVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { "data-qa": "url-field:UrlSegment" }
const _hoisted_2 = {
  key: 0,
  "data-qa": "url-field:UrlSegment"
}
const _hoisted_3 = { class: "_flexb90" }
const _hoisted_4 = { class: "_flex _jc-fe _gap-1 _pt-1" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 3,
  class: "_pt-1"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_external_link = _resolveComponent("external-link")
  const _component_text_field = _resolveComponent("text-field")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _normalizeProps(_guardReactiveProps({..._ctx.$attrs, ..._ctx.$props})), {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["_wbbw", { '_cf': $options.isCondensedLayout }])
      }, [
        (!$props.isEditing && $props.isUrlClickable)
          ? (_openBlock(), _createBlock(_component_external_link, {
              key: 0,
              class: "gfu-link gfu-link--accent",
              href: $options.formattedBaseUrl + _ctx.model,
              "data-qa": "url-field:UrlLink"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.formattedBaseUrl), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.model || '...'), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["href"]))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass({ '_fl _mt-2': $options.isCondensedLayout }),
              "data-qa": "url-field:UrlText"
            }, [
              _createTextVNode(_toDisplayString($options.formattedBaseUrl), 1 /* TEXT */),
              (!$props.isEditing)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.model || '...'), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)),
        ($props.isEditing)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["gfu-flex__container _gap-1", { '_fl _ml-1': $options.isCondensedLayout }])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_text_field, {
                  ref: "customUrlNameInput",
                  modelValue: _ctx.model,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model) = $event)),
                  class: "_mt-0",
                  "show-label": false,
                  onKeyup: [
                    _withKeys($options.confirmUrlChange, ["enter"]),
                    _withKeys($options.cancelUrlEditing, ["esc"])
                  ],
                  "data-qa": "url-field:UrlInput"
                }, null, 8 /* PROPS */, ["modelValue", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("a", {
                  class: _normalizeClass(['gfu-btn--toggler gfu-btn gfu-btn--circle gfu-btn--accent', { 'gfu-btn--disabled': $props.urlHasError }]),
                  disabled: $props.urlHasError,
                  onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.confirmUrlChange && $options.confirmUrlChange(...args)), ["prevent"])),
                  "data-qa": "url-field:SaveUrl"
                }, [
                  _createVNode(_component_base_icon, { name: "check" })
                ], 10 /* CLASS, PROPS */, _hoisted_5),
                _createElementVNode("a", {
                  class: "gfu-btn--toggler gfu-btn gfu-btn--circle gfu-btn--light-alt",
                  onClick: _cache[2] || (_cache[2] = (...args) => ($options.cancelUrlEditing && $options.cancelUrlEditing(...args))),
                  "data-qa": "url-field:CancelUrl"
                }, [
                  _createVNode(_component_base_icon, { name: "times" })
                ])
              ])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        (!$props.isEditing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "edit", { onEditClick: $options.startUrlEditing })
            ]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */))
}